module.exports = __webpack_public_path__ + "img/huawei-ict-academy.a40e857d.png";